"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toWrapped = exports.toCache = void 0;
const wrapped_1 = require("@rixio/wrapped");
const domain_1 = require("./domain");
function toCache(wrapped) {
    switch (wrapped.status) {
        case "fulfilled":
            return domain_1.createFulfilledCache(wrapped.value);
        case "pending":
            return domain_1.pendingCache;
        case "rejected":
            return domain_1.createRejectedCache(wrapped.error);
    }
}
exports.toCache = toCache;
function toWrapped(cache) {
    switch (cache.status) {
        case "fulfilled":
            return wrapped_1.createFulfilledWrapped(cache.value);
        case "idle":
        case "pending":
            return wrapped_1.pendingWrapped;
        case "rejected":
            return wrapped_1.createRejectedWrapped(cache.error);
    }
}
exports.toWrapped = toWrapped;
